import React, { useState, useEffect, useMemo } from "react";
import "../../Styles/TableStyles.scss";
import { useTable, Column, useSortBy, Row, useRowSelect } from "react-table";
import EventServices from "../../services/EventServices";
import moment from "moment";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  changeCurrentMemberMenu,
  // screenChange
} from "../../store/screenSlice";
import { screenConfig } from "../../config/screenConfig";
import { useAppSelector, useAppDispatch } from "../../store/hooks";
import { RootState } from "../../store/store";
import dayjs from "dayjs";
import OrderServices from "../../services/OrderServices";
import {
  setCurrentOrderId,
  setOrderCurrentPage,
  setOrderPaginate,
  setOrderType,
  setSearchElement,
  setUpdateSortBy,
  setUpdateSortType,
} from "../../store/orderApiSlice";
import RoundButtonWithIcon from "../StyledComp/RoundButtonWithIcon";
import LeftArrowIcon from "../../Images/LeftArrowIcon";
import { AiOutlineCloseCircle } from "react-icons/ai";
import * as routeConfig from "../../config/routes";
import { Modal, Button, Nav } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import AlertWithModal from "../utilityComponents/AlertWithModal";
import { saveAs } from 'file-saver';
import styled from 'styled-components';
import { SecondaryWhiteButton } from "../StyledComp/StyledComp";

const ExportButton = styled.button`
  background-color: white;
  border: 1px solid #04aa6d;
  color: #04aa6d;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s ease;
  
  &:hover {
    background-color: #04aa6d;
    color: white;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

interface IOrder {
  Id: string | null;
  BarId: string | null;
  FirstName: string | null;
  LastName: string | null;
  PhoneNumber: string | null;
  Email: string | null;
  AdmitDate: string | null;
  CreatedAt: string | null;
  TransactionAmount: number | null;
  TransactionType: number | null;
  DatePaid: string | null;
  StatusName: string | null;
  OrderType: string | null;
}

const OrderList: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [orderList, setOrderList] = useState<IOrder[]>([]);
  const [isAllSelected, setIsAllSelectd] = useState<boolean>(false);
  const updateSortBy = useSelector(
    (state: RootState) => state.orderapislice.SortBy
  );
  console.log(updateSortBy);
  const [SortField, setSortField] = useState(updateSortBy);
  const updateSortType = useSelector(
    (state: RootState) => state.orderapislice.SortType
  );
  console.log(updateSortType);
  const [SortType, setSortType] = useState(updateSortType);
  const currentPage = useSelector(
    (state: RootState) => state.orderapislice.CurrentPage
  );
  const updatePage = useSelector(
    (state: RootState) => state.orderapislice.Paginate
  );
  const [showAlertModal, setShowAlertModal] = useState<boolean>(false);
  const [alertBody, setAlertBody] = useState<string>("");
  const [alertTitle, setAlertTitle] = useState<string>("");
  const [CurrentAPICallPage, setCurrentAPICallPage] = useState(currentPage);
  const [CurrentPage, setCurrentPage] = useState(currentPage);
  const [OrderPerAPICall, setOrderPerAPICall] = useState(updatePage);
  const [TotalRecords, setTotalRecords] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const inputSearch = useSelector(
    (state: RootState) => state.orderapislice.searchElement
  );
  const [searchInput, setSearchInput] = useState(inputSearch);
  const [showInputs, setShowInputs] = useState(inputSearch);
  const [searchvisibility, setSearchvisibility] = useState(false);

  let startIndex = 0;
  let endIndex = 0 + OrderPerAPICall;
  const location = useLocation();
  // const history = useHistory();
  const params = new URLSearchParams(location.search);
  const currentMember = useAppSelector((state) => state.currentMember);
  console.log(currentMember);
  const MemberId: string | null = params.get("MemberId");
  const decodedId = MemberId ? window.atob(MemberId) : null;
  console.log(MemberId, "MemberId#########");
  const updateOrderType = useSelector(
    (state: RootState) => state.orderapislice.OrderType
  );
  console.log(updateOrderType);
  const [FilterBy, setFilterBy] = useState(updateOrderType);

  const handleExport = async () => {
    try {
      setIsLoading(true);
      const response = await OrderServices.exportOrders(orderListAPIParams);
      if (response.data) {
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'orders.xlsx');
      }
    } catch (error) {
      console.error('Error exporting orders:', error);
      setAlertBody('Failed to export orders. Please try again.');
      setAlertTitle('Export Failed');
      setShowAlertModal(true);
    } finally {
      setIsLoading(false);
    }
  };

  const [hasFilters, setHasFilters] = useState(false);
  const [showMoreModal, setShowMoreModal] = useState(false);
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [sponsorText, setSponsorText] = useState('');
  const [filterByDate, setFilterByDate] = useState('');
  const [paymentStatus, setPaymentStatus] = useState('');
  const [transactionType, setTransactionType] = useState('');
  const [paCredit, setPaCredit] = useState('');

  let orderListAPIParams = {
    SortType: SortType,
    SortBy: SortField,
    CurrentPage: CurrentAPICallPage,
    Paginate: OrderPerAPICall,
    searchElement: searchInput,
    MemberId: decodedId,
    OrderType: FilterBy,
    startDate: startDate ? dayjs(startDate).format('YYYY-MM-DD') : undefined,
    endDate: endDate ? dayjs(endDate).format('YYYY-MM-DD') : undefined,
    filterByDate: filterByDate,
    paCredit: paCredit
  };

  const roleCapabilites = useAppSelector(
    (state) => state.user.roleCapabilities
  );

  const columns = React.useMemo<Column<any>[]>(
    () => [
      { id: "Id", Header: "Order ID", accessor: "OrderId" },
      // { id: "BarId", Header: "Member ID", accessor: "BarId" },
      { id: "BarId", Header: "BarID", accessor: "BarId" },
      { id: "Name", Header: "Name", accessor: "Name" },
      {
        id: "OrderDate",
        Header: "Order Date",
        accessor: (OrderDate) => {
          return moment(OrderDate.OrderDate)
            .local()
            .format("MM-DD-YYYY HH:mm A");
        },
      },
      {
        id: "TransactionType",
        Header: "Transaction Type",
        accessor: "TransactionType",
      },
      {
        id: "TransactionAmount",
        Header: "Amount",
        accessor: "TransactionAmount",
      },
      { id: "OrderStatus", Header: "Order Status", accessor: "OrderStatus" },
    ],
    []
  );

  const getOrderList = async () => {
    setIsLoading(true);
    const response = await OrderServices.getOrderList(orderListAPIParams);
    console.log("response...", response.data.data);
    if (response.data.data != null) {
      if (response.data.hasErrors) {
        setShowAlertModal(true);
        setAlertTitle("Database Error");
        setAlertBody(response.data.errors[0].sqlMessage);
        return;
      }
      console.log("Success:", response.data.data);
      setTotalRecords(response.data.data.Pagination[0].TotalRecords);
      setOrderList(response.data.data.Orders);
      // dispatch(updateEventList(response.data.data));
      dispatch(setOrderCurrentPage(orderListAPIParams.CurrentPage));
      dispatch(setSearchElement(orderListAPIParams.searchElement));
      dispatch(setUpdateSortType(orderListAPIParams.SortType));
      dispatch(setUpdateSortBy(orderListAPIParams.SortBy));
      dispatch(setOrderPaginate(orderListAPIParams.Paginate));
      dispatch(setOrderType(orderListAPIParams.OrderType));
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    getOrderList();
  }, [
    SortField,
    SortType,
    CurrentAPICallPage,
    searchInput,
    orderListAPIParams.MemberId,
    OrderPerAPICall,
    FilterBy,
  ]);
  const handleFilterBy = (data: any) => {
    console.log(data);
    setFilterBy(data);
    setCurrentPage(1);
    setCurrentAPICallPage(1);
  };
  const handleChange = (value: number) => {
    setCurrentPage(value);
    setCurrentAPICallPage(value);
    console.log(value, CurrentAPICallPage, CurrentPage, searchInput);
  };

  const handleSearchInputChange = (e: any) => {
    setShowInputs(e.target.value);
  };

  const handleSearchButtonClick = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSearchInput(showInputs);
    setCurrentPage(1);
    setCurrentAPICallPage(1);
  };

  const handleClearSearch = () => {
    console.log("Clear button clicked");
    console.log(params.has("MemberId"));
    // orderListAPIParams.MemberId=''
    if (params.has("MemberId")) {
      params.delete("MemberId");
      navigate({ search: params.toString() });
    }
    orderListAPIParams = {
      ...orderListAPIParams,
      MemberId: null,
    };
    setShowInputs("");
    setSearchInput("");
    setCurrentPage(1);
    setCurrentAPICallPage(1);
  };

  const handleSort = (newSortField: string) => {
    console.log("Handle sort called");
    setOrderList([]);
    setCurrentPage(1);
    setCurrentAPICallPage(1);
    startIndex = 0;
    endIndex = 0 + OrderPerAPICall;
    setSortType(
      newSortField === SortField
        ? SortType === "Desc"
          ? "Asc"
          : "Desc"
        : "Asc"
    );
    setSortField(newSortField);
  };
  const renderSortIcon = (field: string) => {
    if (field === SortField) {
      return SortType === "Desc" ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          width="17"
          height="20"
          fill="#fff"
        >
          <path d="M4 13h16l-8 8z" />
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          width="17"
          height="20"
          fill="#fff"
        >
          <path d="M12 3l8 8H4z" />
        </svg>
      );
    } else {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          width="17"
          height="20"
          fill="#fff"
        >
          <path d="M12 3l8 8H4z" />
          <path d="M4 13h16l-8 8z" />
        </svg>
      );
    }
  };
  const data = useMemo(() => orderList, [orderList]);

  console.log("OrderList:", data);

  const clearFilters = () => {
    setStartDate(null);
    setEndDate(null);
    setFilterByDate('');
    setPaymentStatus('');
    setTransactionType('');
    setPaCredit('');
    setHasFilters(false);
    setShowMoreModal(false);
    setCurrentAPICallPage(1);
    setSearchInput('');
  };

  useEffect(() => {
    if (!hasFilters && !startDate && !endDate && !filterByDate && !paymentStatus && !transactionType && !paCredit) {
      getOrderList();
    }
  }, [hasFilters, startDate, endDate, filterByDate, paymentStatus, transactionType, paCredit]);

  const callApplyFilters = () => {
    if (startDate && endDate && endDate < startDate) {
      setShowAlertModal(true);
      setAlertTitle("Invalid Date Range");
      setAlertBody("End date cannot be before start date");
      return;
    }
    
    if ((startDate && !endDate) || (!startDate && endDate)) {
      setShowAlertModal(true);
      setAlertTitle("Date Range Required");
      setAlertBody("Please select both start and end dates or clear both");
      return;
    }

    setHasFilters(true);
    setShowMoreModal(false);
    setCurrentAPICallPage(1);
    getOrderList();
  };

  const getOrderDetail = (e: any, order: IOrder) => {
    if (
      !roleCapabilites.some((obj: any) =>
        Object.values(obj).includes("orders.view")
      )
    ) {
      alert("No Access");
      return;
    }
    // let data = row.original;
    console.log("getMemberDetail:", order.Id);
    dispatch(setCurrentOrderId(Number(order.Id)));
    // console.log("getMemberDetail:", event);
    //setting as 1
    // dispatch(assignCurrentMemberBarId(data.BarId));
    if (e.target.localName == "td") {
      console.log("ROW clicked");
      // dispatch(assignCurrentEvent(event));
      // dispatch(changeCurrentMemberMenu(screenConfig.viewOrder));
      navigate(routeConfig.ORDER_DETAIL_URL, { replace: false });
    }
    // if (event.target.localName == "input") {
    //   console.log("Checkbox clicked");
    //   handleChange(event);
    // }
  };

  const TableInstance = useTable(
    {
      columns,
      data,
    },
    useSortBy
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    // selectedFlatRows,
  } = TableInstance;

  let index = 0; //to revisit later
  const rowUpdate = (event: React.ChangeEvent<HTMLSelectElement>): void => {
    setOrderPerAPICall(Number(event.target.value));
    setCurrentPage(1);
    setCurrentAPICallPage(1);
  };
  return (
    <>
      {/* <EventsMenu /> */}
      <div className="dashboard-content-wrapper mt-2 pb-3">
        <div className="d-flex justify-content-between mb-3">
          <h1 className="page-heading mt-3">Order List</h1>
          <form onSubmit={(e) => handleSearchButtonClick(e)}>
            <div
              style={{
                display: "flex",
                position: "relative",
                alignItems: "center",
                marginTop: "10px",
              }}
            >
              <input
                type="text"
                placeholder="Search"
                value={showInputs}
                onChange={handleSearchInputChange}
                style={{
                  padding: " 5px 0px 5px 40px",
                  backgroundColor: "rgb(250 250 250)",
                  border: "0px",
                  borderBottom: "1px solid #000",
                  width: "450px",
                }}
              />
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="25"
                viewBox="0 0 29.999 30"
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "1%",
                  transform: "translateY(-50%)",
                }}
              >
                <path
                  id="Path_410"
                  data-name="Path 410"
                  d="M97.348,125.943a4.922,4.922,0,0,0,1.211-1.028l7.662-7.662c.161-.161.264-.183.448-.037a11.212,11.212,0,0,0,5.24,2.3,11.863,11.863,0,1,0-5.534-20.866,11.78,11.78,0,0,0-3.75,5.439,11.86,11.86,0,0,0,1.864,10.958c.139.183.139.279-.029.448q-3.974,3.952-7.934,7.927a2.909,2.909,0,0,0-.756,1.005v.587a1.623,1.623,0,0,0,1,.939C96.959,125.943,97.157,125.943,97.348,125.943Zm16.558-8.749a9.369,9.369,0,1,1,9.343-9.409A9.372,9.372,0,0,1,113.906,117.194Z"
                  transform="translate(-95.77 -95.95)"
                  fill="currentColor"
                ></path>
              </svg>
              <button
                className="btn"
                type="submit"
                // onClick={handleSearchButtonClick}
                style={{
                  marginLeft: "8px",
                  background: "#366287",
                  color: "#FFFFFF",
                }}
              >
                Search
              </button>
              <button
                className="btn"
                onClick={handleClearSearch}
                style={{
                  marginLeft: "8px",
                  background: "#757575",
                  color: "#FFFFFF",
                }}
              >
                Clear
              </button>
            </div>
          </form>
          <div></div>
        </div>
        <div className="memberlist-table">
          <Nav
            className="custom-tabs d-flex justify-content-start text-center align-item-center"
            style={{ marginBottom: "1rem" }}
            variant="tabs"
            activeKey={FilterBy}
          >
            <div className="heading_small" style={{ marginRight: "0.5rem" }}>
              Filter By:
            </div>
            <Nav.Item>
              <Nav.Link
                className="nav-small-label nav-tag-style"
                eventKey=""
                onClick={() => handleFilterBy("")}
              >
                All
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                className="nav-small-label nav-tag-style"
                eventKey="Function"
                onClick={() => handleFilterBy("Function")}
              >
                Function
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                className="nav-small-label nav-tag-style"
                eventKey="Membership"
                onClick={() => handleFilterBy("Membership")}
              >
                Membership
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                className="nav-small-label nav-tag-style"
                eventKey="Seminar"
                onClick={() => handleFilterBy("Seminar")}
              >
                Seminar
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                className="nav-small-label nav-tag-style"
                eventKey="Video"
                onClick={() => handleFilterBy("Video")}
              >
                Video
              </Nav.Link>
            </Nav.Item>
            
            <Nav.Item>
              <Nav.Link
                className={`nav-small-label nav-tag-style ${hasFilters ? 'active' : ''}`}
                eventKey="More"
                onClick={() => setShowMoreModal(true)}
                style={{
                  backgroundColor: hasFilters ? '#04aa6d' : 'transparent',
                  color: hasFilters ? 'white' : '#000000',
                  border: '1px solid #04aa6d'
                }}
              >
                More
              </Nav.Link>
            </Nav.Item>
            <Nav.Item className={'d-none'}>
              <SecondaryWhiteButton
                onClick={handleExport}
                disabled={isLoading}
              >
                Export to Excel
              </SecondaryWhiteButton>
            </Nav.Item>
          </Nav>          
          <Modal show={showMoreModal} onHide={() => setShowMoreModal(false)} centered backdropStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
            <div className="modal-content" style={{ backgroundColor: 'white' }}>
              <Modal.Header closeButton style={{ backgroundColor: 'white', padding: '1rem' }}>
                <Modal.Title>More Filters</Modal.Title>
              </Modal.Header>
              <Modal.Body style={{ backgroundColor: 'white', padding: '1rem' }}>
                <div className="d-flex flex-column gap-3">
                  <div className="d-flex flex-column gap-2">
                    <div className="d-flex flex-column">
                      <label className="mb-1">Start Date</label>
                      <DatePicker
                        selected={startDate}
                        onChange={(date) => setStartDate(date)}
                        className="form-control"
                        dateFormat="MM/dd/yyyy"
                      />
                    </div>
                    <div className="d-flex flex-column">
                      <label className="mb-1">End Date</label>
                      <DatePicker
                        selected={endDate}
                        onChange={(date) => setEndDate(date)}
                        className="form-control"
                        dateFormat="MM/dd/yyyy"
                      />
                    </div>
                  </div>
                  <div className="d-flex flex-column d-none">
                    <label className="mb-1">Payment Status</label>
                    <select
                      value={paymentStatus}
                      onChange={(e) => setPaymentStatus(e.target.value)}
                      className="form-control"
                    >
                      <option value="">Select Payment Status</option>
                      <option value="paid">Paid</option>
                      <option value="due">Dues</option>
                    </select>
                  </div>
                  <div className="d-flex flex-column d-none">
                    <label className="mb-1">Transaction Type</label>
                    <select
                      value={transactionType}
                      onChange={(e) => setTransactionType(e.target.value)}
                      className="form-control"
                    >
                      <option value="">Select Transaction Type</option>
                      <option value="credit">Credit</option>
                      <option value="debit">Debit</option>
                    </select>
                  </div>

                </div>
              </Modal.Body>
              <Modal.Footer style={{ backgroundColor: 'white', padding: '1rem' }}>
                <Button variant="secondary" onClick={() => {
                  clearFilters();
                }} style={{
                  backgroundColor: '#f8f9fa',
                  borderColor: '#dee2e6',
                  color: '#6c757d',
                  padding: '8px 16px',
                  borderRadius: '4px',
                  marginRight: '8px'
                }}>
                  Clear Filters
                </Button>
                <Button variant="primary" onClick={() => {
                  callApplyFilters();
                }} style={{
                  backgroundColor: '#04aa6d',
                  borderColor: '#04aa6d',
                  color: 'white',
                  padding: '8px 16px',
                  borderRadius: '4px',
                  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                }}>
                  Apply Filters
                </Button>
              </Modal.Footer>
            </div>
          </Modal>
          <table>
            <thead>
              <tr>
                {/* <th>
                <input
                  type="checkbox"
                  name="allselect"
                  // checked={!userData.some((user) => user?.isChecked !== true)}
                  // onChange={handleChange}
                />
              </th> */}
                <th onClick={() => handleSort("Id")}>
                  ID{renderSortIcon("Id")}
                </th>
                <th onClick={() => handleSort("BarId")}>
                  Bar ID{renderSortIcon("BarId")}
                </th>
                <th onClick={() => handleSort("FirstName")}>
                  Name{renderSortIcon("FirstName")}
                </th>
                <th onClick={() => handleSort("OrderDate")}>
                  OrderDate{renderSortIcon("OrderDate")}
                </th>
                <th onClick={() => handleSort("TransactionType")}>
                  TransactionType{renderSortIcon("TransactionType")}
                </th>
                <th onClick={() => handleSort("DatePaid")}>
                  DatePaid{renderSortIcon("DatePaid")}
                </th>
                {/* <th onClick={() => handleSort("TransactionAmount")}>Amount{renderSortIcon("TransactionAmount")}</th> */}
                <th onClick={() => handleSort("OrderStatus")}>
                  OrderStatus{renderSortIcon("OrderStatus")}
                </th>
                <th onClick={() => handleSort("OrderType")}>
                  OrderType{renderSortIcon("OrderType")}
                </th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <tr>
                  <td align="center" colSpan={9}>
                    <span>Loading...</span>
                  </td>
                </tr>
              ) : (
                orderList.map((order) => (
                  <tr key={order.Id} onClick={(e) => getOrderDetail(e, order)}>
                    {/* <th>
                  <input
                    type="checkbox"
                    name={event.Id as string}
                    // checked={event?.isChecked}
                    // onChange={(e) => handleChange(e)}
                  />
                </th> */}
                    <td>{order.Id} </td>
                    <td>{order.BarId} </td>
                    <td>
                      {order.FirstName} {order.LastName}{" "}
                    </td>
                    <td>
                      {order.CreatedAt != null
                        ? dayjs(order.CreatedAt).format("MM-DD-YYYY HH:mm A")
                        : "--"}
                    </td>
                    <td>
                      {order.TransactionType ? order.TransactionType : "-"}{" "}
                    </td>
                    <td>
                      {order.DatePaid != null
                        ? dayjs(order.DatePaid).format("MM-DD-YYYY")
                        : "--"}
                    </td>
                    {/* <td>{order.TransactionAmount} </td> */}
                    <td>{order.StatusName} </td>
                    <td>{order.OrderType} </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
      <div
        className="container mb-2"
        style={{ paddingTop: "10px", borderTop: "1px solid #ddd" }}
      >
        <div className="grid left"></div>
        <div className="grid center">
          {/* Pagenation-start */}
          <div
            className="horizontal-wrapper-centeraligned"
            style={{ marginTop: "10px" }}
          >
            <div
              className="round-button-div"
              style={{ width: "30px", height: "30px", marginRight: "10px" }}
            >
              <RoundButtonWithIcon
                icon={<LeftArrowIcon height={15} width={8} />}
                onClick={() => handleChange(CurrentPage - 1)}
                disabled={CurrentPage === 1}
              />
            </div>

            {orderList.length > 1 ? (
              <div className="heading_medium">
                {" "}
                <span style={{ fontWeight: "500" }}>
                  {1 + (CurrentPage - 1) * OrderPerAPICall}{" "}
                </span>{" "}
                -{" "}
                <span style={{ fontWeight: "500" }}>
                  {orderList.length + (CurrentPage - 1) * OrderPerAPICall}{" "}
                </span>
                of <span style={{ fontWeight: "500" }}>{TotalRecords} </span>{" "}
                Events
              </div>
            ) : (
              <div>
                <div className="heading_medium">
                  <span style={{ fontWeight: "500" }}>{TotalRecords} </span>{" "}
                  Events
                </div>
              </div>
            )}
            <div
              style={{
                height: "30px",
                width: "30px",
                transform: "rotate(180deg)",
                marginLeft: "10px",
              }}
            >
              {" "}
              <RoundButtonWithIcon
                icon={<LeftArrowIcon height={15} width={8} />}
                onClick={() => handleChange(CurrentPage + 1)}
                disabled={
                  CurrentPage === Math.ceil(TotalRecords / OrderPerAPICall)
                }
              />{" "}
            </div>
          </div>
          {/* Pagenation-end */}
        </div>
        <div className="grid right">
          <div className="w-100 mt-2">
            <select
              className="dropdown-control-large-insidetextfield"
              name="pagesize"
              style={{ border: "1px solid #ddd", height: "30px" }}
              onChange={(e) => {
                rowUpdate(e);
              }}
              value={OrderPerAPICall}
            >
              <option value="10">10 rows</option>
              <option value="25">25 rows</option>
              <option value="50">50 rows</option>
              <option value="100">100 rows</option>
              <option value="150">150 rows</option>
              <option value="200">200 rows</option>
            </select>
          </div>
        </div>
      </div>
      {showAlertModal ? (
        <AlertWithModal
          title={alertTitle}
          body={alertBody}
          show={showAlertModal}
          onClose={() => setShowAlertModal(false)} // Close the modal
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default OrderList;
